import { informationPeriodTypeName } from '@/constants/index';

// 日時指定のロジック
// 常時表示の場合
const getAllowedAlways = (allowedAlways: boolean) => {
  if (allowedAlways) {
    return true;
  } else {
    return false;
  }
};

// 曜日指定の場合
const getAllowedDow = (allowedDays: string[]) => {
  const getDayOfWeek = () => {
    const daysOfWeek = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    const currentDate = new Date();
    const dayIndex = currentDate.getDay();

    return daysOfWeek[dayIndex];
  };
  const currentDay = getDayOfWeek();

  if (allowedDays.includes(currentDay)) {
    return true;
  } else {
    return false;
  }
};

// 日時指定
// 引数timeの配列: [startTime, endTime]
const getAllowedDayAndTime = (time: number[]) => {
  const currentTimestamp = Date.now();
  const startTime = time[0];
  const endTime = time[1];

  if (currentTimestamp >= startTime && currentTimestamp <= endTime) {
    return true;
  } else {
    return false;
  }
};

interface Period {
  type: string;
  value: boolean | string[] | number[];
}

/**
 * 現在時刻と設定されている表示期間を比較してbooleanを返す
 * @param {Period} period periodの配列
 * @return {boolean} 表示フラグ
 */
export const isDateInPeriod = (period: Period): boolean => {
  const { type, value } = period;

  switch (type) {
    case informationPeriodTypeName.ALWAYS:
      return getAllowedAlways(value as boolean);

    case informationPeriodTypeName.DOW:
      return getAllowedDow(value as string[]);

    case informationPeriodTypeName.RANGE:
      return getAllowedDayAndTime(value as number[]);

    default:
      return false;
  }
};
